export default (pos) => {
    var searchFormElement = document.getElementById("searchForm");
    
    var startPos = searchFormElement.scrollTop;
    
    var initialDistance = searchFormElement.scrollTop-pos;

    var x = 0;
    var startTime = Date.now();

    return new Promise(function(resolve,reject){

        var previousTop = searchFormElement.scrollTop;

        var scroll = function(){

          if(searchFormElement.scrollTop != previousTop) {
                reject("interrupted");
                return;
            }

          var distance = searchFormElement.scrollTop-pos;

          x = Math.round(2+Math.abs(distance/(searchFormElement.offsetHeight/2))*6);
          
          if(distance > 0)
          {
            searchFormElement.scrollTop -= x
          }
          else
          {
            searchFormElement.scrollTop += x
          }

          if(Math.abs(distance)<10) {
              resolve();
              return;
          }

          previousTop = searchFormElement .scrollTop;
          setTimeout(scroll, 0);
        }
        setTimeout(scroll, 0);        
    })  

}



/** WEBPACK FOOTER **
 ** ./app/utils/smoothScroll.js
 **/